import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useMemo } from 'react';
export var useSelectedTagsToDisplay = function useSelectedTagsToDisplay(internalValue, internalOptions) {
  return useMemo(function () {
    if (!internalValue.length) {
      return [];
    }

    var internalOptionValues = internalOptions.map(function (option) {
      return option.value;
    });
    var matchingValueIndices = [];
    internalValue.forEach(function (value) {
      var matchedIndex = internalOptionValues.indexOf(value);

      if (matchedIndex > -1) {
        matchingValueIndices = [].concat(_toConsumableArray(matchingValueIndices), [matchedIndex]);
      }
    });
    return matchingValueIndices.map(function (index) {
      return internalOptions[index];
    });
  }, [internalValue, internalOptions]);
};